export default __webpack_public_path__ + "static/media/teamBg.529c0c73.jpg";